import * as React from "react";
import { FieldInputProps } from "formik";

// Types
import Feedback from "../types/Feedback.interface";

// Misc.
import operators from "./Operators.lib";
import { isArray } from "./Array.lib";

const useFeedback = (
  feedbackArray: Feedback[],
  fieldValue: FieldInputProps<any>
) => {
  const [feedback, setFeedback] = React.useState<any>("");

  React.useEffect(() => {
    if (fieldValue) {
      let showFeedback: boolean | string = false;

      feedbackArray.forEach((feedbackItem): void => {
        const {
          condition,
          conditionValue,
          checkProp,
          feedback: feedbackString,
        } = feedbackItem;

        const fieldValueIsArray = isArray(fieldValue.value);

        /**
         * If the Fieldvalue is an Array, we can be sure that the Field is a Checkbox.
         * Therefore we set the `valueToCheckAgainst` to the first item of the
         * Fieldvalue-Array. Currently we don't support more than one Feedback
         * per Checkbox-Answer.
         */
        const fieldValueItem = fieldValueIsArray
          ? fieldValue.value[0]
          : fieldValue.value;

        console.log(fieldValue);

        // If there is no fieldValueItem yet, set Feedback to `false` and return.
        if (!fieldValueItem) {
          setFeedback(false);
          return;
        }

        /**
         * Decide whether to use to ID or the Value of the Fieldvalue to do the check against.
         *
         * `id` would be "Show Feedback if ID is equal to [ID_OF_ANSWER]"
         * `value` would be "Show Feedback if Value is greater than 5"
         */
        const valueToCheckAgainst =
          checkProp === "id" ? fieldValueItem.id : fieldValueItem.value;

        /**
         * Actually perform the check, but only if the `value` of the `fieldItem` is set.
         * We don't want to show the feedback yet if the `value` is not set, because
         * otherwise empty TextInputs in Radio- or Checkbox-Answers would trigger the Feedback
         * even if there is no real Answer is given yet (e.g. InputField is still empty)
         */

        if (
          operators[condition](valueToCheckAgainst, conditionValue) &&
          fieldValueItem.value
        ) {
          showFeedback = feedbackString;
        }
      });

      if (showFeedback) {
        setFeedback(showFeedback);
      } else {
        setFeedback(false);
      }
    }
  }, [fieldValue, feedbackArray]);

  return [feedback];
};

export default useFeedback;
